import { gql } from 'apollo-boost';

export default gql`
  mutation groceryOrderPartialRefund($input: GroceryOrderPartialRefundInput!) {
    groceryOrderPartialRefund(input: $input)
  }
`;
